import * as yup from 'yup';

// src/helpers/validationSchemas/menu/itemGroupSchema.ts
var itemGroupSchema = yup.object().shape({
  name: yup.string().trim().required("nameRequired"),
  posName: yup.string().trim().required("posNameRequired"),
  kdsName: yup.string().trim().required("kdsNameRequired"),
  checkName: yup.string().trim().required("checkNameRequired"),
  onlineName: yup.string().trim().required("onlineNameRequired")
});

export { itemGroupSchema };
